import { motion } from "framer-motion";
import { Facebook, ArrowUpRight } from "lucide-react";
import { FACEBOOK_URL, FACEBOOK_PAGE_HREF } from "@/data";

const IFRAME_SRC =
  `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(FACEBOOK_PAGE_HREF)}` +
  `&tabs=timeline&width=500&height=680&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`;

export default function FacebookFeed() {
  return (
    <section id="facebook" data-testid="facebook-section" className="py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <div className="font-mono-accent text-xs uppercase tracking-[0.2em] text-accent mb-4">// Facebook</div>
            <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight">
              Οι τελευταίες μας αναρτήσεις.
            </h2>
            <p className="mt-4 text-muted-foreground leading-relaxed max-w-md">
              Ενημερώσεις, επιτυχίες και τα νέα του φροντιστηρίου «Φυσική Επιλογή» — απευθείας από τη
              σελίδα μας στο Facebook, αυτόματα.
            </p>
            <a
              data-testid="facebook-follow-btn"
              href={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-8 inline-flex items-center gap-2 bg-[#1877F2] text-white font-mono-accent text-xs uppercase tracking-widest px-6 py-3.5 rounded-sm hover:opacity-90 transition-opacity"
            >
              <Facebook className="h-4 w-4" />
              Ακολουθήστε μας
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="flex justify-center lg:justify-end"
          >
            <div className="w-full max-w-[500px] bg-white border border-border rounded-sm overflow-hidden">
              <iframe
                title="Facebook — Φυσική Επιλογή"
                data-testid="facebook-iframe"
                src={IFRAME_SRC}
                className="w-full"
                style={{ border: "none", overflow: "hidden", height: "680px" }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen={true}
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
